import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as moment from 'moment';
import { formatAmount } from '../../../../utils';


const generatePDF = (title, headers, data, filename) => {
  const doc = new jsPDF({
    orientation: 'landscape',
  });

  doc.text(title, 14, 10);

  autoTable(doc, {
    head: headers,
    body: data,
    startY: 20,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
  });

  doc.save(filename);
};

export const generateSchoolPaymentsPDF = (user) => {
  const headers = [
    ['Fecha de pago', 'Nombre del CE', 'ID del CE', 'Forma de pago', 'Cuenta receptora', 'Referencia', 'Monto $', 'Concepto', 'Tipo de Plan', 'Fecha de Vencimiento', 'Estatus']
  ];
  const data = user.map((item) => {
    let receptor = [
      item?.receptor?.name ? `Benef.: ${item?.receptor?.name}` : '',
      item?.receptor?.bank?.code ? `Entidad Banc.: ${item?.receptor?.bank?.name}` : '',
      item?.receptor?.account_number ? `Número de cuenta: ${item?.receptor?.account_number}` : '',
    ].filter(Boolean).join(',\n');

    const userPlan = item?.plan_users?.length ? item?.plan_users[0] : null;

    return [
      moment(item?.created_at).format('DD-MM-YYYY'),
      item?.user?.fullname,
      item?.user?.dea_code,
      item?.payment_method.name,
      receptor,
      item?.reference,
      formatAmount(item?.amount),
      item?.concept || '',
      userPlan?.plan?.name || '--',
      userPlan ? moment(userPlan?.next_payment).format('DD-MM-YYYY') : '--',
      item?.status_text,
    ];
  });

  generatePDF('Reporte de centros educativos', headers, data, 'centros educativos.pdf');
};

export const generateTeacherPaymentsPDF = (user) => {
  const headers = [
    ['Fecha de pago', 'Nombre del profesor', 'Documento', 'Cuenta receptora', 'Forma de pago', 'Referencia', 'Monto $', 'Concepto', 'Tipo de Plan', 'Fecha de Vencimiento', 'Estatus']
  ];
  const data = user.map((item) => {
    let receptor = [
      item?.receptor?.name ? `Benef.: ${item?.receptor?.name}` : '',
      item?.receptor?.bank?.code ? `Entidad Banc.: ${item?.receptor?.bank?.name}` : '',
      item?.receptor?.account_number ? `Número de cuenta: ${item?.receptor?.account_number}` : '',
    ].filter(Boolean).join(',\n');

    const userPlan = item?.plan_users?.length ? item?.plan_users[0] : null;

    return [
      moment(item?.created_at).format('DD-MM-YYYY'),
      item?.user?.fullname,
      `${item?.user?.document_type?.name}${item?.user?.document}`,
      receptor,
      item?.payment_method.name,
      item?.reference,
      formatAmount(item?.amount),
      item?.concept || '',
      userPlan?.plan?.name || '--',
      userPlan ? moment(userPlan?.next_payment).format('DD-MM-YYYY') : '--',
      item?.status_text,
    ]
  });

  generatePDF('Reporte de profesores', headers, data, 'profesores.pdf');
};

